import EventManager, { preventDefault, stopEvent, stopPropagation } from '../../../lib/_util/EventManager';
export default EventManager;
export { preventDefault, stopPropagation, stopEvent, };
